import clsx from "clsx";
import React from "react";
import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colorSystem } from "../../theme";

import { ArrowForwardRounded } from "@mui/icons-material";
import { useClient } from "../../hooks/useClient";
import { ClientNutritionEntriesListItem } from "./ClientNutritionEntriesListItem";
import { InternalNutritionEntryDto } from "../../utils/chart";
import { ClientNutritionEntriesListTableHeader } from "./ClientNutritionEntriesListTableHeader";
import { NutritionEntryDto } from "@growth-machine-llc/stridist-api-client";

const useStyles = makeStyles((theme) => ({
  constainer: {
    width: "100%",
    overflowX: "scroll",
  },

  title: {
    color: colorSystem.gray,
    textTransform: "uppercase",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: colorSystem.gray11,
    padding: theme.spacing(1.8, 2.3, 1.8, 1.2),
    cursor: "pointer",
    marginBottom: theme.spacing(3),
  },

  chevronIcon: {
    transform: "rotate(-90deg)",
  },

  table: {
    width: "100%",
    minWidth: theme.breakpoints.values.md,
    padding: theme.spacing(1, 0),
    transition: "max-height 0.25s ease-in",
  },

  smallTable: {
    minWidth: theme.breakpoints.values.sm,
  },

  targetListHeader: {
    display: "flex",
    overflow: "scroll",
    margin: theme.spacing(0, -1),
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },

  createButton: {
    color: theme.palette.secondary.main,
    backgroundColor: "transparent",
    fontSize: 16,
    fontWeight: 600,
    boxShadow: "none",
    height: theme.spacing(4),
    position: "absolute",
    bottom: -3,
    right: 0,
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },

  createButtonIcon: {
    color: theme.palette.primary.main,
    fontSize: "25px!important",
  },

  tableBody: {
    position: "relative",
  },
}));

export interface ClientNutritionEntriesListProps {
  title: string;
  entries: NutritionEntryDto[];
  refresh?: () => void;
  handleAddNutrition?: () => void;
  isProgram?: boolean;
}

export function ClientNutritionEntriesList(
  props: ClientNutritionEntriesListProps,
) {
  const { title, entries, refresh, isProgram, handleAddNutrition, ...other } =
    props;
  const s = useStyles();

  const showAdvancedNutrition =
    entries.reduce(
      (acc, entry) =>
        acc +
        entry.alcohol +
        entry.cholesterol +
        entry.fiber +
        entry.sodium +
        entry.sugar +
        entry.transFat,
      0,
    ) > 0;

  return (
    <Box className={s.constainer}>
      <Box className={clsx(s.table, !showAdvancedNutrition && s.smallTable)}>
        <ClientNutritionEntriesListTableHeader
          showAdvancedNutrition={showAdvancedNutrition}
        />
        <Box className={s.tableBody}>
          {entries.map((entry, index) => (
            <ClientNutritionEntriesListItem
              showAdvancedNutrition={showAdvancedNutrition}
              entry={entry}
              key={index}
              refresh={refresh}
              handleAddNutrition={handleAddNutrition}
              isProgram={isProgram}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
